import type { App } from 'vue';

declare global {
  interface Window {
    /** Tells embed widgets (payment-method-create, etc.) to use Lock's Sentry client. */
    __AUTHVIA_EMBED__?: { sentry?: 'host' };
  }
}

/**
 * Declares that Lock owns Sentry for embedded Authvia widgets.
 * Call before any widget module loads.
 */
export function declareLockOwnsSentry(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.__AUTHVIA_EMBED__ = {
    ...(window.__AUTHVIA_EMBED__ ?? {}),
    sentry: 'host',
  };
}

/**
 * Re-attaches the Sentry Vue error handler after lazy-loaded embed plugins install.
 */
export async function rebindLockSentryToApp(app: App): Promise<void> {
  if (typeof window === 'undefined') {
    return;
  }

  declareLockOwnsSentry();

  const Sentry = await import('@sentry/vue');
  if (!Sentry.isInitialized()) {
    return;
  }

  Sentry.attachErrorHandler(app, {
    attachProps: true,
    attachErrorHandler: true,
  });
}
